module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('filebox-dashboard', {
    attrs: {
      "icons": _vm.icons,
      "myFiles": _vm.myFiles,
      "companyFiles": _vm.companyFiles,
      "loadingMyFiles": _vm.loadingMyFiles,
      "loadingCompanyFiles": _vm.loadingCompanyFiles
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22818d10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/containers/filebox/FileboxContainer.vue
// module id = 3180
// module chunks = 3